import { ChartLineIcon } from 'lucide-react';

export const NavChart = ChartLineIcon;
